



























































































































































import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import { AxiosRequestConfig } from 'axios'
import { FindProdutoUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { ProdutoProjection, ProdutoVitrineVirtual, TipoDeProduto } from '@/models/Produto'
import { ItemVitrineVirtual, VitrineVirtualModule } from '@/store/vuex/produto/VitrineVirtualStore'
import DialogoDeSelecionarVariante from '@/components/produto/DialogoDeSelecionarVariante.vue'
import { Produto, ProdutoFilho } from '@/models'
import { ItemDaVenda } from '@/models'
import DialogoDoCarrinhoDaVitrineVirtual from './DialogoDeCarrinhoDaVitrineVirtual.vue'
import DialogoDeFiltrosDaVitrineVirtual, { FiltrosDaVitrine } from '@/views/application/produtos/DialogoDeFiltrosDaVitrineVirtual.vue'


@Component({
	components: {
		DialogoDeFiltrosDaVitrineVirtual,
		DialogoDeSelecionarVariante,
		DialogoDoCarrinhoDaVitrineVirtual,
	},
})
export default class DialogoDeVitrineVirtual extends Vue {
	@Ref() dialogoDeSelecionarVariante!: DialogoDeSelecionarVariante
	@Ref() dialogoDoCarrinhoDaVitrineVirtual!: DialogoDoCarrinhoDaVitrineVirtual
	@Ref() dialogoDeFiltrosDaVitrineVirtual!: DialogoDeFiltrosDaVitrineVirtual

	selecionandoProduto = false
	filtroAplicado: FiltrosDaVitrine | null = null
	findProdutoUseCase = new FindProdutoUseCase()
	mostra = false
	busca = ''

	produtos: ProdutoVitrineVirtual[] = []
	categorias: string[] = []

	carregando = false
	pagina = 0
	tamanhoPagina = 16
	ultimaPagina = false
	produtoCarregandoId: string | null = null
	produtosOriginais: ProdutoVitrineVirtual[] = []
	categoriaSelecionada: string | null = null

	private debounceTimer: number | null = null

	async mostrar() {
		this.mostra = true
		await this.$nextTick()
		requestAnimationFrame(() => {
			this.carregarPrimeiraPagina()
		})
	}

	fechar() {
		this.mostra = false
	}

	@Watch('categoriaSelecionada')
	onCategoriaChange() {
		if (!this.mostra) return
		this.aplicarFiltrosLocais()
	}

	onBuscaInput() {
		if (this.debounceTimer) {
			window.clearTimeout(this.debounceTimer)
		}

		this.debounceTimer = window.setTimeout(() => {
			if (!this.mostra) return
			this.aplicarFiltrosLocais()
		}, 350)
	}

	async carregarPrimeiraPagina() {
		this.pagina = 0
		this.ultimaPagina = false
		this.produtos = []
		await this.buscarProdutos(false)
	}

	async carregarProximaPagina() {
		if (this.carregando || this.ultimaPagina) return
		this.pagina += 1
		await this.buscarProdutos(true)
	}

	async buscarProdutos(acumular: boolean) {
		this.carregando = true

		try {
			const params: any = {
				tipos: ['Padrão', 'Com Variantes', 'Composto'] as TipoDeProduto[],
				page: this.pagina,
				size: this.tamanhoPagina,
			}

			const config: AxiosRequestConfig = {}

			const produtos = await this.findProdutoUseCase.findOtimizado(params, config)

			//ESTÁ CHUMBADO FIXO PARA CONSEGUIR TESTAR NESSA PRIMEIRA VERSÃO
			const content = (produtos && produtos.content ? produtos.content : []).map((produto: ProdutoProjection) => ({
				...produto,
				imagemUrl: this.getImagemProduto(produto),
				cores: ['vermelho', 'branco'],
				tamanhos: ['P', 'M', 'G'],
				preco: 139.9,
			}))

			this.produtosOriginais = acumular
				? [...this.produtosOriginais, ...content]
				: content

			this.aplicarFiltrosLocais()

			this.ultimaPagina = produtos ? produtos.last : true
			this.atualizarCategorias(content, !acumular)
		} catch (error) {
			AlertModule.setError('Erro ao carregar produtos.')
		} finally {
			this.carregando = false
		}
	}

	atualizarCategorias(produtos: ProdutoProjection[], resetar: boolean) {
		const categoriasAtuais = resetar ? [] : [...this.categorias]

		produtos.forEach((produto) => {
			if (
				produto.categoriaNome &&
				!categoriasAtuais.includes(produto.categoriaNome)
			) {
				categoriasAtuais.push(produto.categoriaNome)
			}
		})

		this.categorias = categoriasAtuais.sort((a, b) => a.localeCompare(b))
	}

	onScroll(event: Event) {
		const target = event.target as HTMLElement
		if (!target) return

		const chegouPertoDoFim =
			target.scrollTop + target.clientHeight >= target.scrollHeight - 300

		if (chegouPertoDoFim) {
			this.carregarProximaPagina()
		}
	}

	async selecionarProduto(produtoSelecionado: ProdutoVitrineVirtual) {
		this.produtoCarregandoId = produtoSelecionado.id

		try {
			const produtoCompleto: Produto = await this.findProdutoUseCase.findProdutoById(produtoSelecionado.id)

			if (produtoCompleto.tipo === 'Com Variantes') {
				this.dialogoDeSelecionarVariante &&
				this.dialogoDeSelecionarVariante.abrir(Promise.resolve(produtoCompleto))
				return
			}

			this.adicionarProdutoAoCarrinho(produtoCompleto as ProdutoFilho)
		} catch (error) {
			AlertModule.setError('Erro ao buscar detalhes do produto.')
		} finally {
			this.produtoCarregandoId = null
		}
	}

	adicionarProdutoAoCarrinho(produto: ProdutoFilho | null) {
		if (!produto) return

		const itensAtualizados = [...this.produtosSelecionados]
		const indiceExistente = itensAtualizados.findIndex((item) => item.produto.id === produto.id)

		const produtoDaVitrine: ProdutoVitrineVirtual = {
			...produto,
			categoriaNome: (produto as any).categoriaNome || (produto as any).categoria?.nome || 'Sem categoria',
			preco: produto.preco || 0,
			tamanhos: (produto as any).tamanhos || ['P', 'M', 'G'],
			cores: (produto as any).cores || ['vermelho', 'branco'],
		}

		if (indiceExistente >= 0) {
			itensAtualizados[indiceExistente].quantidade += 1
		} else {
			itensAtualizados.push({
				produto: produtoDaVitrine,
				quantidade: 1,
			})
		}

		VitrineVirtualModule.setDados({
			produtos: itensAtualizados,
		})
	}

	getImagemProduto(produto: ProdutoProjection): string {
		if (!produto.urlImagens) {
			return 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'
		}

		if (typeof produto.urlImagens === 'string') {
			return produto.urlImagens
		}

		return 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'
	}

	get isDark(): boolean {
		return this.$vuetify.theme.dark
	}

	deveMostrarTooltip(texto: string): boolean {
		return !!texto && texto.length > 55
	}

	formatarPreco(preco: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(preco)
	}

	normalizarCor(cor: string): string {
		const mapa: Record<string, string> = {
			'preto': '#000000',
			'branco': '#ffffff',
			'azul': '#1e3a8a',
			'vermelho': '#dc2626',
			'verde': '#16a34a',
			'amarelo': '#facc15',
			'cinza': '#6b7280',
			'bege': '#d6c2a1',
			'marrom': '#7c4a21',
			'rosa': '#ec4899',
			'roxo': '#7c3aed',
			'laranja': '#f97316',
			'offwhite': '#f5f5f0',
			'off-white': '#f5f5f0',
			'creme': '#f3e7d3',
		}

		if (!cor) {
			return '#cccccc'
		}

		const chave = cor.toLowerCase().trim()
		return mapa[chave] || cor
	}

	async limparFiltros() {
		this.busca = ''
		this.categoriaSelecionada = null
		this.filtroAplicado = null
		this.aplicarFiltrosLocais()
	}

	get produtosSelecionados(): ItemVitrineVirtual[] {
		return VitrineVirtualModule.dados.produtos || []
	}

	get quantidadeTotalNoCarrinho(): number {
		return this.produtosSelecionados.reduce((total, produto) => total + (produto.quantidade || 0), 0)
	}
	
	obterQuantidadeSelecionada(produtoId: string): number {
		const item = this.produtosSelecionados.find((itemSelecionado) => itemSelecionado.produto.id === produtoId)
		return item ? item.quantidade : 0
	}

	produtoEstaSelecionado(produtoId: string): boolean {
		return this.obterQuantidadeSelecionada(produtoId) > 0
	}

	incrementarQuantidade(produto: ProdutoVitrineVirtual) {
		this.selecionarProduto(produto)
	}

	decrementarQuantidade(produtoId: string) {
		const itensAtualizados = [...this.produtosSelecionados]
		const itemExistente = itensAtualizados.find((item) => item.produto.id === produtoId)

		if (!itemExistente) return

		if (itemExistente.quantidade > 1) {
			itemExistente.quantidade -= 1
		} else {
			const itensFiltrados = itensAtualizados.filter((item) => item.produto.id !== produtoId)

			VitrineVirtualModule.setDados({
				produtos: itensFiltrados,
			})
			return
		}

		VitrineVirtualModule.setDados({
			produtos: itensAtualizados,
		})
	}

	abrirResumoDoCarrinho() {
		this.dialogoDoCarrinhoDaVitrineVirtual.mostrar()
	}

	abrirDialogoDeFiltrosDeVitrineVirtual(){
		this.dialogoDeFiltrosDaVitrineVirtual.mostrar()
	}

	selecionarCategoria(categoria: string, toggle?: () => void) {
		const mesmaCategoria = this.categoriaSelecionada === categoria

		this.categoriaSelecionada = mesmaCategoria ? null : categoria

		if (toggle) {
			toggle()
		}

		this.aplicarFiltrosLocais()
	}

	finalizarCarrinho(itens: ItemVitrineVirtual[]) {
		if (!itens || !itens.length) return

		itens.forEach((item) => {
			const itemDaVenda = this.criarItemDaVenda(item.produto, item.quantidade)
			this.$emit('input', itemDaVenda)
		})

		VitrineVirtualModule.resetar()
		this.fechar()
	}

	criarItemDaVenda(produto: ProdutoVitrineVirtual, quantidade: number): ItemDaVenda {
		return {
			id: '',
			produto: {
				id: produto.id,
				nome: produto.nome,
				sku: produto.sku,
				urlImagens: produto.urlImagens,
				preco: produto.preco || 0,
			} as any,
			quantidade,
			quantidadeLida: 0,
			desconto: { isPercentual: true, valor: 0.0 },
			preco: produto.preco || 0,
			precoDeCusto: 0,
			idConjunto: null,
			descontoVarejo: 0,
			percentualCashback: 0,
			diasParaEfetivarCashback: 0,
			isBrinde: false,
			idItemNotaOrigem: null,
			chaveNotaOrigem: null,
			diasParaExpirarCashback: 0,
			possuiDescontoPorTabela: false,
			valorDescontoRateadoDoItem: 0,
			itemDeDevolucao: false,
			isTotalmenteTrocado: false,
			motivoCancelamento: null,
			isCompra: false,
			idItemOrigem: '',
			isDaVendaReaberta: false,
			vendedor: null,
			autenticadoParaLiberarProdutoSemEstoque: false,
			vendaOrigemDoItem: null,
			valorFreteRateado: 0,
			isItemReferenteATroca: false,
			isDeOutraLoja: false,
			percentualDescontoTabelaPreco: 0,
			precoDeCustoReal: 0,
			selecionadoViaVitrineVirtual: true,
		}
	}

	produtoEstaCarregando(produtoId: string): boolean {
		return this.produtoCarregandoId === produtoId
	}

	//FOI SOLICITADO QUE DEIXASSE PREPARADO PARA APLICAR O FILTRO EM CIMA DO QUE TIVER SIDO BUSCADO AO INVÉS DE BUSCAR NOVAMENTE NO BACKEND
	aplicarFiltrosLocais() {
		let produtosFiltrados = [...this.produtosOriginais]

		if (this.busca) {
			const termo = this.busca.toLowerCase().trim()

			produtosFiltrados = produtosFiltrados.filter((produto) =>
				(produto.nome || '').toLowerCase().includes(termo) ||
			(produto.sku || '').toLowerCase().includes(termo) ||
			(produto.categoriaNome || '').toLowerCase().includes(termo))
		}

		if (this.categoriaSelecionada) {
			const categoriaSelecionada = this.categoriaSelecionada.toLowerCase().trim()

			produtosFiltrados = produtosFiltrados.filter((produto) => (produto.categoriaNome || '').toLowerCase().includes(categoriaSelecionada))
		}

		if (this.filtroAplicado?.tamanho) {
			const tamanho = this.filtroAplicado.tamanho.toLowerCase().trim()
			produtosFiltrados = produtosFiltrados.filter((produto) => (produto.tamanhos || []).some((item) => String(item).toLowerCase().includes(tamanho)))
		}

		if (this.filtroAplicado?.cor) {
			const cor = this.filtroAplicado.cor.toLowerCase().trim()
			produtosFiltrados = produtosFiltrados.filter((produto) => (produto.cores || []).some((item) => String(item).toLowerCase().includes(cor)))
		}

		if (this.filtroAplicado?.categoria) {
			const categoria = this.filtroAplicado.categoria.toLowerCase().trim()
			produtosFiltrados = produtosFiltrados.filter((produto) => (produto.categoriaNome || '').toLowerCase().includes(categoria))
		}

		if (this.filtroAplicado?.genero) {
			const genero = this.filtroAplicado.genero.nome.toLowerCase().trim()
			produtosFiltrados = produtosFiltrados.filter((produto: any) => String(produto.genero || '').toLowerCase().includes(genero))
		}

		if (this.filtroAplicado?.estacao) {
			const estacao = this.filtroAplicado.estacao.nome.toLowerCase().trim()
			produtosFiltrados = produtosFiltrados.filter((produto: any) => String(produto.estacao || '').toLowerCase().includes(estacao))
		}

		if (this.filtroAplicado?.produtoSimilar) {
			const produtoSimilar = this.filtroAplicado.produtoSimilar.toLowerCase().trim()
			produtosFiltrados = produtosFiltrados.filter((produto) => (produto.nome || '').toLowerCase().includes(produtoSimilar))
		}

		this.produtos = produtosFiltrados
	}

	aplicarFiltros(filtros: FiltrosDaVitrine) {
		this.filtroAplicado = filtros
		this.aplicarFiltrosLocais()
	}
}
